import apiV2 from "api-v2";

interface QuoteCommentRequest {
	inviteId: number;
	quoteId: number;
}

interface QuoteCommentResponse {
	comment: string;
	revision: number;
}

interface SaveQuoteCommentPayload {
	comment: string;
}

export const getQuoteComment = async (
	request: QuoteCommentRequest
): Promise<QuoteCommentResponse | null> => {
	const response = await apiV2.get<{ data: QuoteCommentResponse | null }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/comment`
	);
	return response.data.data;
};

/**
 * Batch: return latest comment for every quote table, keyed by quote ID.
 */
export const getAllQuoteComments = async (
	inviteId: number
): Promise<Record<number, QuoteCommentResponse | null>> => {
	const response = await apiV2.get<{ data: Record<number, QuoteCommentResponse | null> }>(
		`rfx-invite/${inviteId}/quotes/comments`
	);
	return response.data.data;
};

export const saveQuoteComment = async (
	request: QuoteCommentRequest,
	payload: SaveQuoteCommentPayload
): Promise<QuoteCommentResponse> => {
	const response = await apiV2.post<{ data: QuoteCommentResponse }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/comment`,
		payload
	);
	return response.data.data;
};
